<div class="resize-handle">
  <mat-icon>drag_indicator</mat-icon>
  <div class="inner-indicator">
  </div>
</div>
